export const ITEM_UPLOAD_URL = '/items/new'
export const SIGNUP_URL = '/member/signup/select_type'
export const DAC7_URL = '/dac'
export const UK_REPORTING = '/uk-reporting'
export const NO_CHANGES_TO_TAXES_URL = '/no-changes-to-taxes'
